import { useContext } from 'react';
import { AppContext } from './AppContext';
import type { AppContextState } from './types';

export function useAppContext(): AppContextState {
  return useContext(AppContext);
}
